import{a as n}from"./chunk-EI7MMDWY.js";function r(i){return JSON.parse(JSON.stringify(i))}n(r,"sanitizeJson");export{r as a};
